"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToPrecision = roundToPrecision;
exports.cn = cn;
var clsx_1 = __importDefault(require("clsx"));
var tailwind_merge_1 = require("tailwind-merge");
function roundToPrecision(number, precision) {
    if (precision === void 0) { precision = 2; }
    return (function (factor) { return Math.round(number * factor) / factor; })(Math.pow(10, precision));
}
/**
 * Combines multiple class names into a single string, merging Tailwind CSS classes as needed.
 *
 * This function uses `clsx` to conditionally combine class names and `twMerge` to merge
 * Tailwind CSS classes, ensuring that conflicting classes are handled correctly.
 */
function cn() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    return (0, tailwind_merge_1.twMerge)((0, clsx_1.default)(inputs));
}
//# sourceMappingURL=generic.js.map